<template>
  <div>
    <div class="profile-title-wrap flex">
      <div>
        <a
          class="go-back-wrap"
          href="javascript:;"
          @click="switchTreeOrProfile"
        >
          <i class="el-icon-arrow-left"></i>
          <span :class="viewTime">返回家谱</span>
        </a>
      </div>
      <div class="title-text">{{ titleText }}</div>
      <div class="profile-dropdown-wrap">
        <el-dropdown
          class="has-option"
          placement="bottom"
          trigger="click"
          @command="handleAcation"
        >
          <span class="arrow-down-wrapper">
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="unbindBtn" :command="1"
              >断连</el-dropdown-item
            >
            <el-dropdown-item :command="5">导出资料</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div
      class="relative-profile-wrap"
      id="liveRelative"
      v-loading="profileShade"
    >
      <div class="relative-avatar-wrap">
        <img
          class="nav-avatar"
          @click="handlePreview"
          src="../../../assets/image/cl_user_avatar.png"
          v-real-img="initUserAvatar"
        />
      </div>
      <el-form
        :disabled="editForbit"
        ref="userProfileForm"
        label-width="100px"
        class="user-profile-form"
      >
        <el-form-item
          label="世序"
          class="profile-form-item"
          :class="initFamilyIndex"
        >
          <div class="profile-item-content">
            <span class="content-text">第 {{ nodeInfo.dataGene }} 代</span>
          </div>
        </el-form-item>
        <el-form-item
          label="网名"
          prop="nickName"
          class="profile-form-item name-item"
        >
          <div class="profile-item-content">
            <el-input v-model="userProfile.name"></el-input>
          </div>
        </el-form-item>
        <el-form-item
          label="传联号"
          prop="handNum"
          class="profile-form-item name-item"
        >
          <div class="profile-item-content">
            <el-input v-model="userProfile.handNum"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="姓名" prop="name" class="profile-form-item">
          <div class="profile-item-content">
            <el-input v-model="userProfile.realName"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="性别" prop="sex" class="profile-form-item">
          <div class="profile-item-content">
            <span v-if="userProfile.sex == '男'" class="content-text">男</span>
            <span v-else class="content-text">女</span>
          </div>
        </el-form-item>
        <el-form-item label="生日" prop="name" class="profile-form-item">
          <div class="profile-item-content">
            <el-input v-model="userProfile.birthday"></el-input>
          </div>
        </el-form-item>

        <el-form-item label="乳名" prop="petName" class="profile-form-item">
          <div class="profile-item-content">
            <el-input v-model="userProfile.petName"></el-input>
          </div>
        </el-form-item>
        <el-form-item
          label="出生地"
          prop="birthAddress"
          class="profile-form-item"
        >
          <div class="profile-item-content">
            <el-input
              v-model="userProfile.birthAddress"
              placeholder="输入出生地"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item
          label="常住地"
          prop="placeAddress"
          class="profile-form-item"
        >
          <div class="profile-item-content">
            <el-input
              v-model="userProfile.placeAddress"
              placeholder="输入常住地"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item
          label="个人简介"
          prop="introduction"
          class="profile-form-item"
        >
          <div class="profile-item-content">
            <el-input
              type="textarea"
              v-model="userProfile.introduction"
              resize="none"
              maxlength="200"
              show-word-limit
              :autosize="{ minRows: 2 }"
            ></el-input>
          </div>
        </el-form-item>
      </el-form>
      <!-- <div class="relative-avatar-wrap">
        <img
          class="nav-avatar"
          @click="handlePreview"
          src="../../../assets/image/cl_user_avatar.png"
          v-real-img="initUserAvatar"
        />
      </div>
      <div class="profile-item flex" :class="initFamilyIndex">
        <div class="item-title">世序：</div>
        <div class="item-content">第 {{ nodeInfo.dataGene }} 代</div>
      </div>
      <div class="profile-item flex">
        <div class="item-title">网名：</div>
        <div class="item-content">{{ userProfile.name }}</div>
      </div>
      <div class="profile-item flex">
        <div class="item-title">传联号：</div>
        <div class="item-content">{{ userProfile.handNum }}</div>
      </div>
      <div class="profile-item flex">
        <div class="item-title">姓名：</div>
        <div class="item-content">
          <span>{{ userProfile.realName }}</span>
          <span v-if="userProfile.sex == '男'" class="male">
            <i class="el-icon-male"></i>
          </span>
          <span v-else class="female">
            <i class="el-icon-female"></i>
          </span>
        </div>
      </div>
      <div class="profile-item flex">
        <div class="item-title">生日：</div>
        <div class="item-content">{{ initUserBirthday }}</div>
      </div>
      <div class="profile-item flex">
        <div class="item-title">乳名：</div>
        <div class="item-content">{{ userProfile.petName }}</div>
      </div>
      <div class="profile-item flex">
        <div class="item-title">出生地：</div>
        <div class="item-content">{{ userProfile.birthAddress }}</div>
      </div>
      <div class="profile-item flex">
        <div class="item-title">常驻地：</div>
        <div class="item-content">{{ userProfile.placeAddress }}</div>
      </div>
      <div class="profile-item flex">
        <div class="item-title">个人简介：</div>
        <div class="item-content">{{ userProfile.introduction }}</div>
      </div> -->
    </div>
    <div class="product-exhibition-area">
      <el-tabs
        v-model="activeTab"
        type="card"
        @tab-click="productTabClick"
        :stretch="true"
      >
        <el-tab-pane label="文章" name="first">
          <div v-show="articleModule.showList">
            <div class="product-list-wrap" v-loading="articleModule.load">
              <div
                v-for="(item, index) in articleModule.list"
                :key="index"
                class="list-item"
                @click="viewArticle(item.id)"
              >
                <span>{{ item.title }}</span>
                <span>----------</span>
                <span>{{ initCreateTime(item.created_at) }}</span>
              </div>
              <div
                class="without-anything-wrap"
                v-show="articleModule.list.length == 0"
              >
                <img src="../../../assets/icon/cl_without_anything.png" alt />
                <span>暂无文章</span>
              </div>
            </div>
            <div class="pagination-wrapper">
              <el-pagination
                layout="prev, pager, next"
                ref="articlePage"
                hide-on-single-page
                :total="articleModule.count"
                prev-text="上一页"
                next-text="下一页"
                @current-change="curtArticlePageClick"
              ></el-pagination>
              <!-- @prev-click="prevtArticlePageClick" @next-click="nextArticlePageClick" -->
            </div>
          </div>
          <div v-show="!articleModule.showList">
            <div>
              <a
                class="go-list-wrap"
                href="javascript:;"
                @click="showArticleList"
              >
                <i class="el-icon-arrow-left"></i>
                <span>返回列表</span>
              </a>
            </div>
            <ArticleDetail :productId="articleModule.currentId" />
          </div>
        </el-tab-pane>
        <el-tab-pane label="相册" name="second">
          <div v-show="albumModule.showList">
            <div class="product-list-wrap" v-loading="albumModule.load">
              <div
                v-for="(item, index) in albumModule.list"
                :key="index"
                class="list-item"
                @click="viewAlbum(item.id)"
              >
                <span>{{ item.title }}</span>
                <span>----------</span>
                <span>{{ initCreateTime(item.created_at) }}</span>
              </div>
              <div
                class="without-anything-wrap"
                v-show="albumModule.list.length == 0"
              >
                <img src="../../../assets/icon/cl_without_anything.png" alt />
                <span>暂无相册</span>
              </div>
            </div>
            <div class="pagination-wrapper">
              <el-pagination
                layout="prev, pager, next"
                ref="albumPage"
                hide-on-single-page
                :total="albumModule.count"
                prev-text="上一页"
                next-text="下一页"
                @prev-click="prevtAlbumPageClick"
                @current-change="curtAlbumPageClick"
                @next-click="nextAlbumPageClick"
              ></el-pagination>
            </div>
          </div>
          <div v-show="!albumModule.showList">
            <div>
              <a
                class="go-list-wrap"
                href="javascript:;"
                @click="showAlbumList"
              >
                <i class="el-icon-arrow-left"></i>
                <span>返回列表</span>
              </a>
            </div>
            <AlbumDetail :productId="albumModule.currentId" />
          </div>
        </el-tab-pane>
        <el-tab-pane label="视频" name="third">
          <div v-show="videoModule.showList">
            <div class="product-list-wrap" v-loading="videoModule.load">
              <div
                v-for="(item, index) in videoModule.list"
                :key="index"
                class="list-item"
                @click="viewVideo(item.id)"
              >
                <span>{{ item.title }}</span>
                <span>----------</span>
                <span>{{ initCreateTime(item.created_at) }}</span>
              </div>
              <div
                class="without-anything-wrap"
                v-show="videoModule.list.length == 0"
              >
                <img src="../../../assets/icon/cl_without_anything.png" alt />
                <span>暂无视频</span>
              </div>
            </div>
            <div class="pagination-wrapper">
              <el-pagination
                layout="prev, pager, next"
                ref="videoPage"
                hide-on-single-page
                :total="videoModule.count"
                prev-text="上一页"
                next-text="下一页"
                @prev-click="prevtVideoPageClick"
                @current-change="curtVideoPageClick"
                @next-click="nextVideoPageClick"
              ></el-pagination>
            </div>
          </div>
          <div v-show="!videoModule.showList">
            <div>
              <a
                class="go-list-wrap"
                href="javascript:;"
                @click="showVideoList"
              >
                <i class="el-icon-arrow-left"></i>
                <span>返回列表</span>
              </a>
            </div>
            <VideoDetail :productId="videoModule.currentId" />
          </div>
        </el-tab-pane>
        <el-tab-pane label="音频" name="fourth">
          <div v-show="audioModule.showList">
            <div class="product-list-wrap" v-loading="audioModule.load">
              <div
                v-for="(item, index) in audioModule.list"
                :key="index"
                class="list-item"
                @click="viewAudio(item.id)"
              >
                <span>{{ item.title }}</span>
                <span>----------</span>
                <span>{{ initCreateTime(item.created_at) }}</span>
              </div>
              <div
                class="without-anything-wrap"
                v-show="audioModule.list.length == 0"
              >
                <img src="../../../assets/icon/cl_without_anything.png" alt />
                <span>暂无音频</span>
              </div>
            </div>
            <div class="pagination-wrapper">
              <el-pagination
                layout="prev, pager, next"
                ref="audioPage"
                hide-on-single-page
                :total="audioModule.count"
                prev-text="上一页"
                next-text="下一页"
                @current-change="curtAudioPageClick"
              ></el-pagination>
              <!-- @prev-click="prevtAudioPageClick" @next-click="nextAudioPageClick" -->
            </div>
          </div>
          <div v-show="!audioModule.showList">
            <div>
              <a
                class="go-list-wrap"
                href="javascript:;"
                @click="showAudioList"
              >
                <i class="el-icon-arrow-left"></i>
                <span>返回列表</span>
              </a>
            </div>
            <AudioDetail :productId="audioModule.currentId" />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { apiMap } from "../../../utils/apiMap";
import { getDate } from "../../../utils/date";
import ArticleDetail from "./article-detail";
import AlbumDetail from "./album-detail";
import AudioDetail from "./audio-detail";
import VideoDetail from "./video-detail";
import qs from "qs";
export default {
  name: "true-user",
  props: {
    nodeInfo: Object,
  },
  components: {
    ArticleDetail,
    AlbumDetail,
    AudioDetail,
    VideoDetail,
  },
  data() {
    return {
      profileShade: true,
      editForbit: true,
      userProfile: {},
      activeTab: "first",
      articleModule: {
        count: 0,
        list: [],
        load: true,
        showList: true,
        currentId: 0,
      },
      albumModule: {
        count: 0,
        list: [],
        load: true,
        showList: true,
        currentId: 0,
      },
      videoModule: {
        count: 0,
        list: [],
        load: true,
        showList: true,
        currentId: 0,
      },
      audioModule: {
        count: 0,
        list: [],
        load: true,
        showList: true,
        currentId: 0,
      },
      initMenuClass: "non-option",
      newLiveUser: [],
    };
  },
  computed: {
    ...mapGetters(["fatherTreeNote"]),
    titleText() {
      return this.nodeInfo.name;
    },
    viewTime() {
      return `${this.nodeInfo.clickTime}-${this.nodeInfo.userId}`;
    },
    initFamilyIndex() {
      if (this.nodeInfo.treeType == 1 && this.nodeInfo.mate == false) {
        return "entity";
      } else {
        return "virtual";
      }
    },
    initUserAvatar() {
      if (this.userProfile.thumbHeadImg) {
        return this.userProfile.thumbHeadImg;
      } else {
        return "http://148.70.221.198/pc/image/cl_user_avatar.png";
      }
    },
    initUserBirthday() {
      if (this.userProfile.birthday) {
        return getDate(new Date(this.userProfile.birthday * 1000), ".");
      }
    },
    unbindBtn() {
      if (this.nodeInfo && this.nodeInfo.unbindFlag) {
        this.initMenuClass = "has-option";
        return true;
      } else {
        this.initMenuClass = "non-option";
        return false;
      }
    },
  },
  mounted() {
    if (this.nodeInfo.hasOwnProperty("userId")) {
      this.getUserProfile();
    }
  },
  methods: {
    beArray(arr) {
      return arr instanceof Array;
    },
    getUserProfile() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      var params = `token=${loginUser.token}&userId=${this.nodeInfo.userId}`;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["getProfile"]["method"],
          url: apiMap["getProfile"]["url"],
          data: params,
        })
        .then(function(response) {
          // console.log(response.data.result.data)
          if (response.data.result.statusCode == 1) {
            _this.userProfile = response.data.result.data;
            _this.userProfile.birthday = getDate(
              new Date(response.data.result.data.birthday * 1000),
              "-"
            );
            _this.profileShade = false;
            _this.getUserArticle(1);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    switchTreeOrProfile() {
      this.clearProductTab();
      this.$bus.$emit("switch-tree-profile", {});
    },
    handlePreview() {
      this.$bus.$emit("avatar-preview", {
        url:
          this.userProfile.thumbHeadImg ||
          "http://148.70.221.198/pc/image/cl_user_avatar.png",
      });
    },
    clearProductTab() {
      this.userProfile = {};
      this.profileShade = true;
      this.activeTab = "first";
      this.articleModule.list = [];
      this.articleModule.count = 0;
      this.albumModule.list = [];
      this.albumModule.count = 0;
      this.audioModule.list = [];
      this.audioModule.count = 0;
      this.videoModule.list = [];
      this.videoModule.count = 0;
    },
    handleAcation(action) {
      switch (action) {
        case 1:
          this.unbindRelation();
          break;
        case 5:
          this.printProfile();
          break;
      }
    },
    printProfile() {
      this.$message({
        message: "正在导出资料……",
        duration: 1500,
        offset: 230,
        type: "success",
      });
      var fileName = this.userProfile.realName || "个人资料";
      this.ExportSavePdf(fileName, "#liveRelative");
    },
    unbindRelation() {
      let _this = this;
      // console.log(this.nodeInfo.unbindFlag)
      var tipMsg = "断连后，家谱中不再出现此亲人\n确定要断开吗？";
      if (_this.nodeInfo.unbindFlag.hasOwnProperty("relation")) {
        var spouseCut = ["丈夫", "妻子"];
        var afterCut = ["儿子", "女儿"];
        var beforeCut = ["父亲"];
        var relativeName = _this.nodeInfo.name;
        var relativeKey = _this.nodeInfo.unbindFlag.relation;
        // var relationUserId = _this.nodeInfo.unbindFlag.userId;
        // var copyFlag = 0;
        // var nodeIdArr = [];
        let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
        var params = {};
        // [token,userId,relationUserId,relationName] (意思为：userId 与 relationUserId 断绝 relationName 关系)
        // 不传userId表示 当前登录用户 与 relationUserId 断绝 relationName 关系
        if (spouseCut.includes(relativeKey)) {
          //配偶断连(当前登录用户跟配偶断连)
          tipMsg =
            "断连后，家谱中不再出现 “ " +
            relativeName +
            " ”，且此操作不可以恢复！\n确定要断开吗？";
          params = {
            token: loginUser.token,
            relationUserId: _this.nodeInfo.userId,
            relationName: relativeKey,
          };
        } else if (afterCut.includes(relativeKey)) {
          //子父断连 (当前登录用户跟儿子、女儿断连)
          tipMsg =
            "断连后，你的家谱不再出现包含 “ " +
            relativeName +
            " ” 以下的亲人，\n 确定要断开吗？";
          params = {
            token: loginUser.token,
            relationUserId: _this.nodeInfo.userId,
            relationName: relativeKey,
          };
        } else if (beforeCut.includes(relativeKey)) {
          //父子断连
          // if (_this.fatherTreeNote.hasOwnProperty("copyNode")) {
          //   var copyMark = JSON.parse(_this.fatherTreeNote.copyNode);
          //   let fatherId = _this.nodeInfo.unbindFlag.userId;
          //   for (let i in copyMark) {
          //     if (copyMark[i].hasOwnProperty("userName")) {
          //       nodeIdArr.push(copyMark[i].userId);
          //       copyFlag = 1;
          //       //如果自己的父亲有复制标记，终止循环
          //       if (copyMark[i]["userId"] == fatherId) {
          //         break;
          //       } else {
          //         if (copyMark[i]["userId"] == _this.nodeInfo.userId) {
          //           //如果当前登录者有复制标记，终止循环
          //           relationUserId = _this.nodeInfo.userId;
          //           break;
          //         } else {
          //           _this.unbindRelationTip(copyMark[i]);
          //           return false;
          //         }
          //       }
          //     }
          //   }
          // }

          tipMsg =
            "断连后，你的家谱不再出现 “ " +
            relativeName +
            " ” 以上的亲人，且不可以恢复，确定要断开吗？";
          //当前点击的人跟其父亲断连
          params = {
            token: loginUser.token,
            userId: _this.nodeInfo.userId,
            relationUserId: _this.nodeInfo.unbindFlag.userId,
            relationName: relativeKey,
          };
        }
        _this
          .$confirm(tipMsg, {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            closeOnClickModal: false,
            customClass: "tree-member-change",
            showClose: false,
          })
          .then(() => {
            // if (copyFlag == 1) {
            //   params.copyUserId = nodeIdArr.join(",");
            //   params.family = "1";
            // }
            if (params.hasOwnProperty("relationUserId")) {
              _this
                .$axios({
                  baseURL: apiMap["commonUrl"],
                  method: apiMap["unbindRelation"]["method"],
                  url: apiMap["unbindRelation"]["url"],
                  data: qs.stringify(params, { encode: false }),
                })
                .then(function(response) {
                  // console.log(response.data.result.data)
                  if (response.data.result.statusCode == 1) {
                    if (relativeKey == "父亲") {
                      _this.getClanTree();
                    }
                    _this.$message({
                      message: "操作成功",
                      type: "success",
                      duration: 1500,
                      offset: 230,
                    });
                    _this.$bus.$emit("reload-father-tree", "1");
                    _this.switchTreeOrProfile();
                  } else {
                    _this.$message({
                      message: "操作失败，稍后再试",
                      duration: 1500,
                      offset: 230,
                    });
                  }
                })
                .catch(function(error) {
                  console.log(error);
                });
            }
          })
          .catch(() => {});
      }
    },
    unbindRelationTip(userInfo) {
      var tipMsg = `请先点击 “ ${userInfo.userName} ” ，进行断连后，再操作当前断连。`;
      this.$confirm(tipMsg, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showClose: false,
      })
        .then(() => {})
        .catch(() => {});
    },
    initCreateTime(data) {
      return getDate(new Date(data * 1000), ".");
    },
    productTabClick(tab) {
      switch (tab.index) {
        case "0":
          this.getUserArticle(1);
          break;
        case "1":
          this.getUserAlbum(1);
          break;
        case "2":
          this.getUserVideo(1);
          break;
        case "3":
          this.getUserAudio(1);
          break;
      }
    },
    getUserArticle(page) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["articleList"]["method"],
          url: apiMap["articleList"]["url"],
          params: {
            token: loginUser.token,
            start: page,
            count: 10,
            orderField: "created_at",
            order: "desc",
            userId: _this.nodeInfo.userId,
            type: 4,
          },
        })
        .then(function(response) {
          _this.articleModule.load = false;
          if (response.data.result.statusCode == 1) {
            _this.articleModule.count = response.data.result.count;
            _this.articleModule.list = response.data.result.data;
            _this.$refs.articlePage.internalCurrentPage = page;
          } else {
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getUserAlbum(page) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["albumList"]["method"],
          url: apiMap["albumList"]["url"],
          params: {
            token: loginUser.token,
            start: page,
            count: 10,
            orderField: "created_at",
            order: "desc",
            userId: _this.nodeInfo.userId,
            type: 4,
          },
        })
        .then(function(response) {
          _this.albumModule.load = false;
          if (response.data.result.statusCode == 1) {
            _this.albumModule.count = response.data.result.count;
            _this.albumModule.list = response.data.result.data;
            _this.$refs.albumPage.internalCurrentPage = page;
          } else {
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getUserAudio(page) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["audioList"]["method"],
          url: apiMap["audioList"]["url"],
          params: {
            token: loginUser.token,
            start: page,
            count: 10,
            orderField: "created_at",
            order: "desc",
            userId: _this.nodeInfo.userId,
            type: 4,
          },
        })
        .then(function(response) {
          _this.audioModule.load = false;
          if (response.data.result.statusCode == 1) {
            _this.audioModule.count = response.data.result.count;
            _this.audioModule.list = response.data.result.data;
            _this.$refs.audioPage.internalCurrentPage = page;
          } else {
            if (response.data.result.count == 0) {
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getUserVideo(page) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["videoList"]["method"],
          url: apiMap["videoList"]["url"],
          params: {
            token: loginUser.token,
            start: page,
            count: 10,
            orderField: "created_at",
            order: "desc",
            userId: _this.nodeInfo.userId,
            type: 4,
          },
        })
        .then(function(response) {
          _this.videoModule.load = false;
          if (response.data.result.statusCode == 1) {
            _this.videoModule.count = response.data.result.count;
            _this.videoModule.list = response.data.result.data;
            _this.$refs.videoPage.internalCurrentPage = page;
          } else {
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    prevtArticlePageClick(newPage) {
      this.getUserArticle(newPage);
    },
    curtArticlePageClick(newPage) {
      this.getUserArticle(newPage);
    },
    nextArticlePageClick(newPage) {
      this.getUserArticle(newPage);
    },
    viewArticle(id) {
      this.articleModule.currentId = id;
      this.articleModule.showList = false;
    },
    showArticleList() {
      this.articleModule.showList = true;
    },
    prevtAlbumPageClick(newPage) {
      this.getUserAlbum(newPage);
    },
    curtAlbumPageClick(newPage) {
      this.getUserAlbum(newPage);
    },
    nextAlbumPageClick(newPage) {
      this.getUserAlbum(newPage);
    },
    viewAlbum(id) {
      this.albumModule.currentId = id;
      this.albumModule.showList = false;
    },
    showAlbumList() {
      this.albumModule.showList = true;
    },
    prevtVideoPageClick(newPage) {
      this.getUserVideo(newPage);
    },
    curtVideoPageClick(newPage) {
      this.getUserVideo(newPage);
    },
    nextVideoPageClick(newPage) {
      this.getUserVideo(newPage);
    },
    viewVideo(id) {
      this.videoModule.currentId = id;
      this.videoModule.showList = false;
    },
    showVideoList() {
      this.videoModule.showList = true;
    },
    prevtAudioPageClick(newPage) {
      this.getUserAudio(newPage);
    },
    curtAudioPageClick(newPage) {
      this.getUserAudio(newPage);
    },
    nextAudioPageClick(newPage) {
      this.getUserAudio(newPage);
    },
    viewAudio(id) {
      this.audioModule.currentId = id;
      this.audioModule.showList = false;
    },
    showAudioList() {
      this.audioModule.showList = true;
    },
    getClanTree() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["fatherTree"]["method"],
          url: apiMap["fatherTree"]["url"],
          params: {
            token: loginUser.token,
            family: 1,
          },
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.initClanTree(response.data.result.data, 1);
            setTimeout(() => {
              _this.preUnbindSuccessMsg();
            }, 2500);
          } else {
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    initClanTree(data, generation) {
      let _this = this;
      //没有被发讣告的用户
      if (data["deathFlag"] != 1 && data["status"] == 0) {
        if (!_this.newLiveUser.includes(data.userId)) {
          _this.newLiveUser.push(data.userId);
        }
      }
      let partner = data.partners;
      // 过滤家谱成员配偶 08-17
      // if (_this.beArray(partner)) {
      //   for (let p in partner) {
      //     if (partner[p].hasOwnProperty("status")) {
      //       if (partner[p]["deathFlag"] != 1 && partner[p]["status"] == 0) {
      //         if (!_this.newLiveUser.includes(partner[p].userId)) {
      //           _this.newLiveUser.push(partner[p].userId);
      //         }
      //       }
      //     }
      //   }
      // }
      generation++;
      let Children = data.partnerPublicChildren;
      if (_this.beArray(Children)) {
        for (let i in Children) {
          for (let j in Children[i]) {
            if (Children[i][j].hasOwnProperty("status")) {
              if (
                Children[i][j]["deathFlag"] != 1 &&
                Children[i][j]["status"] == 0
              ) {
                if (!_this.newLiveUser.includes(Children[i][j].userId)) {
                  _this.newLiveUser.push(Children[i][j].userId);
                }
              }
            }
            _this.initClanTree(Children[i][j], generation);
          }
        }
      }
    },
    //发送断连家谱通知
    preUnbindSuccessMsg() {
      if (this.newLiveUser.length > 0) {
        let _this = this;
        let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
        var msgContent = `${loginUser.realName}（操作人）已经成功断开 ${_this.nodeInfo.name} 和他（她）父亲的 关系 ，族谱已经发生了变化，前去查看吧。`;
        var initData = {
          fromId: "admin",
          toArr: _this.newLiveUser,
          msgType: "503",
          msgDesc: "您有一条新消息",
          msgContent: msgContent,
        };
        var requestJson =
          "{\n" +
          '    "SyncOtherMachine": 1, \n' +
          '    "From_Account": "' +
          initData["fromId"] +
          '",\n' +
          '    "To_Account": [\n' +
          '        "' +
          initData["toArr"].join('","') +
          '"\n' +
          "    ],\n" +
          '    "MsgRandom": 19901224,\n' +
          '    "MsgBody": [\n' +
          "        {\n" +
          '            "MsgType": "TIMCustomElem",\n' +
          '             "MsgContent": {\n' +
          '        \t"Data": "' +
          initData["msgType"] +
          '", \n' +
          '        \t"Desc": "' +
          initData["msgDesc"] +
          '", \n' +
          '        \t"Ext": "' +
          initData["msgContent"] +
          '"\n' +
          "   \t }\n" +
          "        }\n" +
          "    ],\n" +
          '    "OfflinePushInfo": {\n' +
          '        "PushFlag": 0,\n' +
          '        "Desc": "' +
          initData["msgDesc"] +
          '",\n' +
          '        "Ext": "' +
          initData["msgContent"] +
          '",\n' +
          '        "AndroidInfo": {\n' +
          '            "Sound": "android.mp3"\n' +
          "        },\n" +
          '        "ApnsInfo": {\n' +
          '            "Sound": "apns.mp3",\n' +
          '            "BadgeMode": 1, \n' +
          '            "Title":"apns title",\n' +
          '            "SubTitle":"apns subtitle", \n' +
          '            "Image":"www.image.com" \n' +
          "        }\n" +
          "    }\n" +
          "}";
        var params = {
          token: loginUser.token,
          data: requestJson,
        };
        _this
          .$axios({
            baseURL: apiMap["commonUrl"],
            method: apiMap["quantitySendMsg"]["method"],
            url: apiMap["quantitySendMsg"]["url"],
            data: qs.stringify(params, { encode: false }),
          })
          .then(function(response) {
            // if (response.data.result.ActionStatus == "OK") {
            //   console.log("断连家谱通知，发送成功！");
            // } else {
            //   console.log("断连家谱通知，发送失败！");
            // }
          });
      }
    },
  },
  watch: {
    viewTime() {
      this.getUserProfile();
    },
  },
};
</script>
<style scoped>
.profile-title-wrap {
  height: 40px;
  color: #ffffff;
  line-height: 40px;
  letter-spacing: 2px;
  z-index: 3;
  justify-content: space-between;
  background-color: #1a70db;
}

.go-back-wrap {
  margin-left: 15px;
  padding: 6px 0;
  color: #fff;
  font-size: 14px;
}

.go-list-wrap {
  display: inline-block;
  margin-left: 15px;
  padding: 6px 0;
  color: #000;
  font-size: 14px;
}

.title-text {
  font-size: 16px;
}

.profile-form-item {
  position: relative;
  width: 700px;
  font-size: 16px;
}

.name-item {
  width: 546px;
}

.relative-profile-wrap {
  position: relative;
  padding: 25px 0 40px;
  min-height: 60px;
  font-size: 16px;
  line-height: 30px;
  background-color: #fff;
}

.content-text {
  color: #606266;
  font-size: 16px;
}

.relative-avatar-wrap {
  position: absolute;
  top: 42px;
  right: 140px;
  width: 100px;
  height: 100px;
}

.relative-avatar-wrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.profile-item {
  padding: 5px 15px 5px 47px;
}

.profile-item .male {
  margin-left: 5px;
  color: #0071ff;
}

.profile-item .female {
  margin-left: 5px;
  color: #ff4081;
}

.item-title {
  width: 11%;
}

.item-content {
  width: 81%;
}

.virtual {
  display: none;
}

.profile-dropdown-wrap {
  width: 50px;
  text-align: center;
}

.product-exhibition-area {
  margin-bottom: 20px;
  background-color: #fff;
}

.add-btn-wrap {
  padding-left: 18px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e4e7ed;
}

.wait-list-wrap {
  border: 1px solid #dcdfe6;
}

.wait-list-container {
  height: 300px;
  padding: 5px 0 5px 15px;
}

.wait-item {
  line-height: 30px;
}

.select-btn-bar {
  padding: 5px 0;
  text-align: center;
  border-top: 1px solid #dcdfe6;
}

.pagination-wrapper {
  margin-bottom: 5px;
  text-align: center;
}

.product-list-wrap {
  height: 320px;
  padding: 10px 15px 10px 20px;
  box-sizing: border-box;
}

.list-item {
  display: flex;
  line-height: 30px;
}

.list-item span:first-child {
  max-width: 560px;
  white-space: nowrap;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
}

.list-item:hover {
  cursor: pointer;
  color: #ff6600;
}

.without-anything-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 30px;
  color: #808080;
}
</style>
